import type {
  CurationToolCriteriaDTO,
  NextQueries,
  NextQueriesFactory,
  Pivot,
} from '@empathyco/playboard-core-domain'
import type {
  PivotableExtraParams,
  RegularFilterConfig,
  RegularFilterSelectedValues,
} from '../../models'
import type { CurationToolDomainService, NextQueriesDomainService } from '../interfaces'
import { inject, injectable } from 'inversify'
import { TYPES } from '../../config/inversify.types'

@injectable()
export class PlatformNextQueriesDomainService implements NextQueriesDomainService {
  public constructor(
    @inject(TYPES.CurationToolDomainService)
    protected curationToolDomainService: CurationToolDomainService<NextQueries>,
    @inject(TYPES.NextQueriesFactory)
    protected nextQueriesFactory: NextQueriesFactory,
  ) {}

  getEmptyInstance(): NextQueries {
    return this.nextQueriesFactory()
  }

  isValid(instance: NextQueries, extraParams: PivotableExtraParams): boolean {
    return this.curationToolDomainService.isValid(instance, extraParams)
  }

  isCriteriaValid(
    criteria: CurationToolCriteriaDTO,
    pivotsConfig: Record<string, RegularFilterConfig>,
  ): boolean {
    return this.curationToolDomainService.isCriteriaValid(criteria, pivotsConfig)
  }

  setCriteria(oldCriteria: CurationToolCriteriaDTO): CurationToolCriteriaDTO {
    return this.curationToolDomainService.setCriteria(oldCriteria)
  }

  arePivotsValid(pivots: Array<Pivot>, pivotsConfig: Record<string, RegularFilterConfig>): boolean {
    return this.curationToolDomainService.arePivotsValid(pivots, pivotsConfig)
  }

  updatePivotValues(
    pivots: Array<Pivot>,
    name: string,
    values: RegularFilterSelectedValues,
  ): Array<Pivot> {
    return this.curationToolDomainService.updatePivotValues(pivots, name, values)
  }
}
